import { Dimensions } from "react-native";

const { width, height } = Dimensions.get("window");

const baseWidth = 600;
const baseHeight = 400;

const w = width > height ? width : height;
const h = height > width ? width : height;

const SCALE_FACTOR = Math.sqrt(Math.sqrt((w / baseWidth) * (h / baseHeight)));

export const scale = size => SCALE_FACTOR * size;

export const styles = {
  $h1: scale(22),
  $h2: scale(18),
  $h3: scale(16),
  $h4: scale(14),
  $h5: scale(10),
  $h6: scale(8),
};
